import { completeSignUpGenericErrorMessage } from '~constants/Constants';
import { ConfigRepository } from '~repositories/ConfigRepository';
import { MessageGroup, MessageRepository } from '~repositories/MessageRepository';
import { UserRepository } from '~repositories/UserRepository';
import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/RampService';
import {
    emitAnalyticsEvent,
    eventTag,
    SignUpTaggingEventType,
    TaggingEventSourceType
} from '~utils/Analytics';

import { LoginSubmittedUseCase } from './LoginSubmittedUseCase';

export class OnlineSignUpSubmittedUseCase {
    private userRepository: UserRepository;
    private configRepository: ConfigRepository;
    private messageRepository: MessageRepository;

    constructor() {
        this.userRepository = diContainer.get(serviceNames.userRepository);
        this.configRepository = diContainer.get(serviceNames.configRepository);
        this.messageRepository = diContainer.get(serviceNames.messageRepository);
    }

    execute = async () => {
        const { emailIdentifierFieldName } = this.configRepository;
        const {
            patchPassword,
            onlineSignUpFormStore,
            userId: existingUserId
        } = this.userRepository;
        const { setSubmitting, values } = onlineSignUpFormStore;
        const { setMessages } = this.messageRepository;
        try {
            setSubmitting(true);
            const { password } = values;
            if (await patchPassword(existingUserId, password)) {
                emitAnalyticsEvent(eventTag.SIGN_UP_SUCCESSFUL, {
                    source: TaggingEventSourceType.IN_STORE,
                    type: SignUpTaggingEventType.COMPLETE,
                    provider: 'standard'
                });

                const accountIdentifier =
                    emailIdentifierFieldName && values[emailIdentifierFieldName];
                if (accountIdentifier && typeof accountIdentifier === 'string') {
                    await new LoginSubmittedUseCase({
                        signInData: {
                            accountIdentifier,
                            password
                        },
                        emitTrackingEvent: false
                    }).execute();
                }
            } else {
                emitAnalyticsEvent(eventTag.SIGN_UP_FAILED, {
                    source: TaggingEventSourceType.IN_STORE,
                    type: SignUpTaggingEventType.API_ERROR_OR_IP_LOCK,
                    provider: 'standard'
                });
                setMessages(MessageGroup.ONLINE_SIGN_UP, [
                    { transKey: completeSignUpGenericErrorMessage }
                ]);
                setSubmitting(false);
            }
        } catch (_) {
            emitAnalyticsEvent(eventTag.SIGN_UP_FAILED, {
                source: TaggingEventSourceType.IN_STORE,
                type: SignUpTaggingEventType.API_ERROR_OR_IP_LOCK,
                provider: 'standard'
            });
            setMessages(MessageGroup.ONLINE_SIGN_UP, [
                { transKey: completeSignUpGenericErrorMessage }
            ]);
            setSubmitting(false);
        }
    };
}
